import type { IAnalyticsEventFormField } from '@sravni/cosago-react-library/lib/types';
import { omit } from 'lodash';
import { type FC, useCallback } from 'react';

import { useAppDispatch } from 'shared/lib';
import { sendEventFillFormField } from 'shared/lib/sendGAEvents';
import { SendEventWrapper } from 'shared/lib/sendGAEvents/SendEventWrapper';
import { useUpdateStateBySelector } from 'shared/lib/useUpdateStateBySelector';

import type { TAdditionalDataFormFields } from 'src/client/entities/creditForm';
import { AdditionalInfoFormValidationSchema } from 'src/client/entities/creditForm';

import { formDataSelector } from 'features/UpdateAdditionalInfo/lib/formDataSelector';
import { submitAdditionalInfoForm } from 'features/UpdateAdditionalInfo/lib/submitAdditionalInfoForm';

import { FormFieldsControls } from '../../AdditionalInfo.config';
import { AdditionalInfoTexts } from '../../AdditionalInfo.texts';
import { AdditionalInfoViewHoc } from '../FormBody/FormBody';

export const Form: FC<
  IFormPopup & {
    shouldRestoreAdditionalData?: boolean;
  }
> = ({
  isLoading,
  isDialog = false,
  onClose,
  setHeader,
  isFormForceOpened,
  onFormSubmit,
  shouldRestoreAdditionalData,
  stepIndex,
  formId,
  submitButtonText = 'Показать предложения',
  isAnyFormStepOpenedInPopup,
}) => {
  const dispatch = useAppDispatch();
  const [formData] = useUpdateStateBySelector(formDataSelector);

  const handleData = async (actualData: TAdditionalDataFormFields, type: string) => {
    // убираем лишние поля, которые нужны только для валидации
    const data = omit(actualData, ['mobilePhone', 'workPhone', 'employerType']) as TAdditionalDataFormFields;
    if (type === 'fullFilled') {
      dispatch(submitAdditionalInfoForm(data));
      onFormSubmit?.(data, isDialog);
    }
    if (isDialog) {
      onClose?.(true);
    }
  };

  const sendAnalyticsEvent = useCallback(
    ({ fieldName }: IAnalyticsEventFormField) => {
      sendEventFillFormField(stepIndex + 1, AdditionalInfoTexts[fieldName as keyof TAdditionalDataFormFields], true);
    },
    [stepIndex],
  );

  return (
    <SendEventWrapper sendEvent={sendAnalyticsEvent}>
      <AdditionalInfoViewHoc
        isDialog={isDialog}
        onDataChanged={handleData}
        defaultData={formData}
        validationSchema={AdditionalInfoFormValidationSchema()}
        isLoading={isLoading}
        additionalProps={{
          setHeader,
          isFormForceOpened,
          shouldRestoreAdditionalData: !!shouldRestoreAdditionalData,
          formId,
          isAnyFormStepOpenedInPopup,
        }}
        formLabels={AdditionalInfoTexts}
        formFieldsControls={FormFieldsControls}
        submitButtonText={submitButtonText}
      />
    </SendEventWrapper>
  );
};
